import { BaseEntity } from "yt-ng-framework";

export class OsobaRadnaOprema extends BaseEntity{
    constructor(){
        super();
    }

    OsobaID: number = null;
    TipRadneOpremeID:number = null;
    VelicinaStavID: number = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.OsobaID=input.OsobaID;
        this.TipRadneOpremeID=input.TipRadneOpremeID;
        this.VelicinaStavID=input.VelicinaStavID;
        return this;
    }

    Serialize(input:OsobaRadnaOprema){
        return input;
    }
}